// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import { TerceraButton } from './TerceraButton';
import { TerceraButtonEvents, TerceraButtonStyle } from '@shared/utils/Enums/ButtonEnums';
import { ColorPickerScreen } from '../screen/ColorPickerScreen';
export class TerceraButtonColorPicker extends TerceraButton {
    constructor() {
        super();
        this.ColorChanged = new CustomEvent();
        this.transparentMask = 'assets/webdesktop/resources/pickerTransparencyTile.svg';
        this.transparentMaskNoColor = 'assets/webdesktop/resources/pickerTransparencyTileCrossed.svg';
    }
    oninit() {
        super.oninit();
        this.observe('coloringButtonColor', this.coloringButtonColor);
    }
    coloringButtonColor(val) {
        if (val) {
            if (val.indexOf('rgba(') !== -1) {
                const valueA = parseFloat(val.split(',')[3]);
                if (valueA === 0) {
                    void this.set({ coloringButtonImage: this.transparentMaskNoColor });
                }
                else {
                    void this.set({ coloringButtonImage: this.transparentMask });
                }
            }
            else if (val === 'transparent') {
                void this.set({ coloringButtonImage: this.transparentMaskNoColor });
            }
            else {
                void this.set({ coloringButtonImage: this.transparentMask });
            }
        }
    }
    private_MouseClick(event) {
        super.private_MouseClick(event);
        const btnClickCallback = this.get('colorPickerClicked');
        if (!isNullOrUndefined(btnClickCallback)) {
            btnClickCallback(this.get('coloringButtonColor'), this.lastMouseClickX, this.lastMouseClickY, this.onColorChanged.bind(this));
        }
        else {
            ColorPickerScreen.ShowScreen(this.lastMouseClickX, this.lastMouseClickY, this.get('coloringButtonColor'), this.onColorChanged.bind(this));
        }
    }
    onColorChanged(newColor) {
        void this.set('coloringButtonColor', newColor);
        this.fire(TerceraButtonEvents.onColorChanged, newColor);
        if (this.ColorChanged) {
            this.ColorChanged.Raise(this, newColor);
        }
    }
}
TerceraButton.extendWith(TerceraButtonColorPicker, {
    data: function () {
        return {
            terceraButtonStyle: TerceraButtonStyle.ColorPicker,
            isColoringButton: true,
            coloringButtonColor: 'transparent',
            BackText: '',
            coloringButtonImage: null,
            colorPickerClicked: null
        };
    }
});
